/**
 * TrustRoomSurface.jsx
 * GRANULLO_TRUST_ROOM_ROLE_EXPANSION_ZERO_COMPROMISE_V1
 *
 * Thin wrapper that renders conviction pages inside the Trust Room shell.
 * Provides TrustRoomNav and logout — the actual page component renders inside.
 * Same components, same spine, different role lens.
 */
import React from 'react';
import { useTrustRoom } from './TrustRoomGate';
import TrustRoomNav from '../../components/TrustRoomNav';

export default function TrustRoomSurface({ children }) {
  const { handleLogout } = useTrustRoom();

  return (
    <div className="min-h-screen" style={{ background: 'var(--shell-bg)' }} data-testid="trust-room-surface">
      <TrustRoomNav onLogout={handleLogout} />
      {children}
    </div>
  );
}
